import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Spinner, Tab, Nav } from 'react-bootstrap';
import camelCaseRecursive from 'camelcase-keys-recursive';
import moment from 'moment';
import { indexBenefitsRequest } from '../../../requests/benefits';
import BenefitCard from '../../Shared/Benefit/BenefitCard';
import BenefitSidePanel from '../../Shared/Benefit/BenefitSidePanel';
import BenefitModalShow from '../../Shared/Benefit/BenefitModalShow';
import categories from './FormOptions';

const categoryMap = {
  health: 0,
  education: 1,
  entertainment: 2,
  sport: 3,
  gastronomy: 4,
  services: 5,
  insurance: 6,
  others: 7
};

const BenefitProfileIndex = () => {
  const dispatch = useDispatch();

  const [benefitsByCategory, setBenefitsByCategory] = useState({});
  const [onRequest, setOnRequest] = useState(false);
  const [key, setKey] = useState('sport');
  const [panelShow, setPanelShow] = useState(false);
  const [panelTitle, setPanelTitle] = useState('');
  const [panelContent, setPanelContent] = useState(null);

  const loadCategory = useCallback(
    category => {
      if (!(category in categoryMap)) return;

      if (benefitsByCategory[category]) return;

      setOnRequest(true);
      indexBenefitsRequest({
        dispatch,
        params: {
          filter_category: categoryMap[category],
          active: moment().format('DD/MM/YYYY'),
          my_job_management: true
        },
        successCallback: res => {
          const formatted = camelCaseRecursive(res.data.data);
          setBenefitsByCategory(prev => ({ ...prev, [category]: formatted }));
        },
        callback: () => setOnRequest(false)
      });
    },
    [benefitsByCategory, dispatch]
  );

  useEffect(() => {
    if (key) loadCategory(key);
  }, [key, loadCategory]);

  const handleShowInfo = benefit => {
    setPanelTitle('Detalle del Beneficio');
    setPanelContent(<BenefitModalShow benefit={benefit} />);
    setPanelShow(true);
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mb-3 mt-3">Beneficios</h2>
        </Col>
      </Row>

      <div className="yellow-wrapper">
        <Tab.Container id="benefit-tabs" activeKey={key} onSelect={setKey}>
          <div className="nav-wrapper mb-3">
            <Nav fill className="ml-employee benefit">
              {categories.map(({ value, label }) => (
                <Nav.Item key={value}>
                  <Nav.Link eventKey={value} className="nav-button mt-3 mr-3 p-0">
                    {label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>

          <Tab.Content>
            {categories.map(({ value }) => (
              <Tab.Pane key={value} eventKey={value}>
                {onRequest && key === value ? (
                  <div className="text-center my-4">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <>
                    {(benefitsByCategory[value] || []).length > 0 ? (
                      <Row className='mt-3'>
                        {(benefitsByCategory[value] || []).map(item => (
                          <Col key={item.id} xs={12} md={4} className="mb-5">
                            <BenefitCard benefits={item} showInfo={handleShowInfo} />
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <div className="text-center text-muted my-5">
                        No hay beneficios disponibles en esta categoría.
                      </div>
                    )}
                  </>
                )}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </div>

      <BenefitSidePanel
        title={panelTitle}
        show={panelShow}
        onHide={() => {
          setPanelShow(false);
          setPanelContent(null);
        }}
      >
        {panelContent}
      </BenefitSidePanel>
    </>
  );
};

export default BenefitProfileIndex;
